import { NotificationItem } from "@/layouts/interfaces/NotificationItem.interface";
import { defineStore } from "pinia";
import { ref, watch } from "vue";

export const useNotificationStore = defineStore("notifications", () => {
  // 🔹 Cargar desde localStorage
  const saved = localStorage.getItem("notifications");
  const notifications = ref<NotificationItem[]>(saved ? JSON.parse(saved) : []);

  // 🔹 Guardar automáticamente cuando cambie el array
  watch(
    notifications,
    (newVal) => {
      localStorage.setItem("notifications", JSON.stringify(newVal));
    },
    { deep: true }
  );

  function addNotification(
    notification: Omit<NotificationItem, "id" | "read">
  ) {
    notifications.value.unshift({
      id: Date.now(),
      read: false,
      ...notification,
    });
  }

  function markAsRead(id: number) {
    const n = notifications.value.find((x) => x.id === id);
    if (n) n.read = !n.read;
  }

  function deleteNotification(id: number) {
    notifications.value = notifications.value.filter((n) => n.id !== id);
  }

  function markAllAsRead() {
    notifications.value.forEach((n) => (n.read = true));
  }

  function clearAll() {
    notifications.value = [];
  }

  return {
    notifications,
    addNotification,
    markAsRead,
    deleteNotification,
    markAllAsRead,
    clearAll,
  };
});
